import { ActionIcon, Tooltip } from '@mantine/core';
import { IconUsers } from '@tabler/icons-react';

type CandidatePickListButtonProps = {
  onClick: () => void;
};

export const CandidatePickListButton = ({
  onClick,
}: CandidatePickListButtonProps) => {
  const label = 'Показать список кандидатов';

  return (
    <Tooltip
      label={label}
      color='otherBlack'
      styles={{
        tooltip: {
          color: 'var(--mantine-color-white)',
          backgroundColor: 'var(--mantine-color-otherBlack-0)',
        },
      }}
      withArrow
    >
      <ActionIcon
        type='button'
        variant='outline'
        color='gray'
        size={38}
        aria-label={label}
        style={{ borderRadius: '50%' }}
        onClick={onClick}
      >
        <IconUsers size={20} />
      </ActionIcon>
    </Tooltip>
  );
};
